import React, { useEffect, useState } from "react";
import Card from "@mui/material/Card";
import Collapse from "@mui/material/Collapse";
import {
  Button,
  CardActions,
  CardContent,
  Typography,
  styled,
} from "@mui/material";
import IconButton, { IconButtonProps } from "@mui/material/IconButton";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

import Grid from "@mui/material/Grid";
import { makeStyles } from "@material-ui/core/styles";
import DateRangeIcon from "@mui/icons-material/DateRange";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { useMutation } from "react-query";

import DownloadIcon from "@mui/icons-material/Download";
import { Backdrop, CircularProgress } from "@mui/material";

import useDownloader from "react-use-downloader";
import { toast } from "react-toastify";
import ConfirmationCard from "../../../components/verification/confirmationCard";

export default function FacilityFileDetail(props: any) {
  const [showInstallmentComponent, setShowInstallmentComponent] = useState(
    false
  );

  const {
    size,
    elapsed,
    percentage,
    download,
    cancel,
    error,
    isInProgress,
  } = useDownloader();
  const handleClick = () => {};

  const handleBackClick = () => {
    props.showInstallmentComponent(false);
    props.setFlagActionTab(false);
    setShowInstallmentComponent(false);
  };

  const useStyles = makeStyles((theme) => ({
    collapse: {
      display: "inherit",
      "&:hover": {
        backgroundColor: "transparent", // remove hover color
      },
      "&.MuiCollapse-entered": {
        backgroundColor: "transparent", // remove click color
      },
    },
  }));

  const [expanded, setExpanded] = React.useState(false);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };
  // collapse

  interface ExpandMoreProps extends IconButtonProps {
    expand: boolean;
  }
  const ExpandMore = styled((props: ExpandMoreProps) => {
    const { expand, ...other } = props;
    return <IconButton {...other} />;
  })(({ theme, expand }) => ({
    transform: !expand ? "rotate(0deg)" : "rotate(180deg)",
    marginLeft: "auto",
    transition: theme.transitions.create("transform", {
      duration: theme.transitions.duration.shortest,
    }),
  }));
  const loanList = {
    title: props.requestDetail?.loanTemplateTitle,
    financialSupplierTitle: props.requestDetail?.financialSupplierTitle,
    finalLoanAmount: props.requestDetail?.loanAmount,
    finalInstallmentCount: props.requestDetail?.installmentCount,
    profitPercentage: props.requestDetail?.profitRate,
    expirationDate_Persian: props.requestDetail?.settlementDatePersian,
    customerFullName: props.requestDetail?.customerFullName,
    customerNationalCode: props.requestDetail?.customerNationalCode,
    birthDatePersian: props.requestDetail?.birthDatePersian,
    customerMobileNumber: props.requestDetail?.customerMobileNumber,
    customerPostalCode: props.requestDetail?.customerPostalCode,
    customerAddress: props.requestDetail?.customerAddress,
    supplierSettlementStatusTitle:
      props.requestDetail?.supplierSettlementStatusTitle,
    loanRequestStatusTitle: props.requestDetail?.loanRequestStatusTitle,
    loanTemplateTitle: props.requestDetail?.loanTemplateTitle,
    englishFirstName: props.requestDetail?.englishFirstName,
    englishLastName: props.requestDetail?.englishLastName,
    digitallSignRequired: props.requestDetail?.digitallSignRequired,
    installmentAmount: props.requestDetail?.installmentAmount,
    stepSpace: props.requestDetail?.stepSpace,
    installmentDuration: props.requestDetail?.installmentDuration,
  };
  const classes = useStyles();

  return (
    <Card
      style={{
        margin: "1.9vh",
        boxShadow:
          "0 0px 1px 0 rgba(0, 0, 0, 0), 0 1px 1px 0 rgba(0, 0, 0, 0.2) !important",
        backgroundColor: "#F9F6F7",
      }}
    >
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <CardContent>
          <Typography paragraph>
            <div>
              <ConfirmationCard
                value={loanList}
                sendFrom={"facility"}
                buttonChild={props.buttonChild}
              />
            </div>
          </Typography>
        </CardContent>
      </Collapse>
      {!expanded ? (
        <CardContent style={{ paddingBottom: "0" }}>
          <Typography paragraph>
            <div style={{ marginBottom: "-18px" }}>
              <Grid
                container
                xs={12}
                spacing={{ xs: 2, md: 3 }}
                columns={{ xs: 4, sm: 8, md: 12 }}
                style={{ backgroundColor: "#F9F6F7" }}
              >
                <Grid
                  item
                  xs={8}
                  md={8}
                  sm={12}
                  style={{
                    backgroundColor: "#F6F8F9",
                    textAlign: "right",
                    margin: "1vh",
                  }}
                  className="confirmFacility"
                >
                  {props.child}
                </Grid>
              </Grid>
            </div>
          </Typography>
        </CardContent>
      ) : (
        ""
      )}
      <CardActions disableSpacing className={classes.collapse}>
        <ExpandMore
          expand={expanded}
          onClick={handleExpandClick}
          aria-expanded={expanded}
          aria-label="show more"
          style={{ padding: "0px", width: "100%" }}
          className="collapsColor bgFacilityFileDetail"
          // , width: "100%", backgroundColor: "#F6F8F9"
          // className="test12"
        >
          {!expanded ? (
            <>
              <Grid
                item
                xs={12}
                style={{
                  backgroundColor: "#EDF2F6",
                  marginLeft: "-1vh",
                  marginRight: "-1vh",
                  marginBottom: "-1vh",
                }}
              >
                <ArrowDropDownIcon
                  style={{
                    height: "24px",
                    width: "24px",
                    marginTop: "0.1vh",
                    color: "#9AAFC4",
                  }}
                />
              </Grid>
            </>
          ) : (
            <div
              style={{
                color: "#1D4A87",
                backgroundColor: "#EDF2F6",
                marginLeft: "-1vh",
                marginRight: "-1vh",
                marginTop: "-1vh",
              }}
            >
              <ArrowDropDownIcon
                style={{ height: "24px", width: "24px", color: "#9AAFC4" }}
              />
            </div>
          )}
        </ExpandMore>
      </CardActions>
    </Card>
  );
}
